(function () {
  const WRAPPER_SELECTOR = "cart-drawer-items";
  const TEXT_DOWN = "Desliza para ver más ↓";
  const TEXT_UP = "Volver arriba ↑";

  let rafScheduled = false;
  let currentScroller = null;

  function getWrapper() {
    return document.querySelector(WRAPPER_SELECTOR);
  }

  function findScroller() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return null;

    const candidates = [
      drawer.querySelector("#CartDrawer-CartItems"),
      drawer.querySelector(".drawer__contents"),
      drawer.querySelector(WRAPPER_SELECTOR),
      drawer.querySelector(".drawer__inner")
    ].filter(Boolean);

    return (
      candidates.find((el) => el.scrollHeight > el.clientHeight + 1) ||
      candidates[0] ||
      null
    );
  }

  function ensureUI(wrapper) {
    if (wrapper.querySelector(".cart-scroll-hint-wrap")) return;

    const fade = document.createElement("div");
    fade.className = "cart-scroll-fade";

    const wrap = document.createElement("div");
    wrap.className = "cart-scroll-hint-wrap";

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cart-scroll-hint";
    btn.textContent = TEXT_DOWN;

    wrap.appendChild(btn);

    wrapper.appendChild(fade);
    wrapper.appendChild(wrap);

    wrapper._cartHintBtn = btn;
  }

  function safeUpdate(updateFn) {
    if (rafScheduled) return;
    rafScheduled = true;

    requestAnimationFrame(() => {
      rafScheduled = false;
      updateFn();
    });
  }

  function setup() {
    const wrapper = getWrapper();
    if (!wrapper) return;

    ensureUI(wrapper);

    const btn = wrapper._cartHintBtn || wrapper.querySelector(".cart-scroll-hint");
    if (!btn) return;

    const scroller = findScroller();
    if (!scroller) return;

    const scrollerChanged = currentScroller !== scroller;
    currentScroller = scroller;

    function getState() {
      const overlay =
        document.querySelector("#CartDrawer .cart-scroll-hint-wrap") ||
        document.querySelector("#CartDrawer .cart-scroll-fade");

      let overlayOverlap = 0;

      if (overlay) {
        const s = scroller.getBoundingClientRect();
        const o = overlay.getBoundingClientRect();

        const overlapTop = Math.max(s.top, o.top);
        const overlapBottom = Math.min(s.bottom, o.bottom);

        overlayOverlap = Math.max(0, overlapBottom - overlapTop);
        overlayOverlap = Math.min(overlayOverlap, scroller.clientHeight);
      }
      
      const effectiveHeight = Math.max(0, scroller.clientHeight - overlayOverlap);

      const hasOverflow = scroller.scrollHeight > effectiveHeight + 2;

      const bottomThreshold = Math.max(12, overlayOverlap + 6);

      const atBottom =
        scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - bottomThreshold;

      const atTop = scroller.scrollTop <= 2;

      return { hasOverflow, atBottom, atTop };
    }

    function update() {
      const { hasOverflow, atBottom, atTop } = getState();

      wrapper.setAttribute("data-cart-overflow", hasOverflow ? "1" : "0");
      wrapper.setAttribute("data-cart-at-top", atTop ? "1" : "0");

      btn.textContent = atBottom ? TEXT_UP : TEXT_DOWN;
      btn.disabled = !hasOverflow;
    }

    function scrollAction() {
      const { hasOverflow, atBottom } = getState();
      if (!hasOverflow) return;

      if (atBottom) {
        scroller.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      const step = Math.round(scroller.clientHeight * 0.6);
      scroller.scrollBy({ top: step, behavior: "smooth" });
    }

    if (!btn.dataset.hintClickBound) {
      btn.dataset.hintClickBound = "1";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollAction();
      });
    }

    if (scrollerChanged) {
      if (scroller._hintScrollHandler) {
        scroller.removeEventListener("scroll", scroller._hintScrollHandler);
      }

      const onScroll = () => safeUpdate(update);
      scroller._hintScrollHandler = onScroll;
      scroller.addEventListener("scroll", onScroll, { passive: true });
    }

    if (!window.__cartHintResizeBound) {
      window.__cartHintResizeBound = true;
      window.addEventListener("resize", () => safeUpdate(update));
    }

    const target =
      document.querySelector("#CartDrawer-CartItems .js-contents") ||
      document.querySelector("#CartDrawer-CartItems") ||
      scroller;

    if (!target.__cartHintObserved) {
      target.__cartHintObserved = true;

      const mo = new MutationObserver(() => safeUpdate(update));
      mo.observe(target, { childList: true, subtree: true });
    }

    safeUpdate(update);
    setTimeout(() => safeUpdate(update), 120);
    setTimeout(() => safeUpdate(update), 350);
    setTimeout(() => safeUpdate(update), 800);
  }

  document.addEventListener("cart-drawer:rendered", setup);
  document.addEventListener("cart:refresh", setup);
  document.addEventListener("shopify:section:load", setup);

  function observeDrawerMount() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return;

    if (drawer.dataset.cartHintObserver === "1") return;
    drawer.dataset.cartHintObserver = "1";

    const mo = new MutationObserver(() => setup());
    mo.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    setup();
    observeDrawerMount();
  });
})();